import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, ChevronsUp, ChevronsDown } from "lucide-react";

const move = (arr, i, j) => { const n = [...arr]; const [x] = n.splice(i, 1); n.splice(j, 0, x); return n; };

export function OrderList({ items, setItems, testId = "order-list" }) {
  const [drag, setDrag] = useState(null);
  return (
    <div className="space-y-1.5" data-testid={testId}>
      {items.map((it, i) => (
        <div key={it.id} draggable onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()}
             onDrop={() => { if (drag !== null && drag !== i) setItems(move(items, drag, i)); setDrag(null); }}
             className={`flex items-center gap-2 rounded-xl border px-3 py-2 bg-slate-900/70 cursor-grab ${drag === i ? "border-blue-500" : "border-slate-800"}`}
             data-testid={`${testId}-item-${i}`}>
          <span className="w-6 text-center font-mono text-xs text-slate-500">{i + 1}</span>
          <span className="min-w-0 flex-1"><span className="block text-sm font-medium truncate" style={it.depth ? { paddingLeft: it.depth * 12 } : undefined}>{it.label}</span>
            {it.sub && <span className="block text-[11px] text-slate-500 truncate">{it.sub}</span>}</span>
          {[[ChevronsUp, 0, "top"], [ArrowUp, i - 1, "up"], [ArrowDown, i + 1, "down"], [ChevronsDown, items.length - 1, "bottom"]].map(([Icon, j, k]) => (
            <button key={k} type="button" disabled={j < 0 || j >= items.length || j === i} onClick={() => setItems(move(items, i, j))}
                    className="p-1.5 rounded-lg hover:bg-slate-800 disabled:opacity-25" data-testid={`${testId}-${k}-${i}`}><Icon size={14} /></button>
          ))}
          {it.onRemove && <button type="button" onClick={it.onRemove} className="text-xs text-red-300 px-1.5 hover:underline" data-testid={`${testId}-remove-${i}`}>Çıkar</button>}
        </div>
      ))}
    </div>
  );
}

export function OrderDialog({ title, hint, items: initial, onSave, onClose }) {
  const [items, setItems] = useState(initial);
  const [busy, setBusy] = useState(false);
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-lg" data-testid="order-dialog">
        <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle></DialogHeader>
        {hint && <p className="text-xs text-slate-400 -mt-2">{hint}</p>}
        <div className="max-h-[60vh] overflow-y-auto pr-1"><OrderList items={items} setItems={setItems} /></div>
        <Button disabled={busy} onClick={async () => { setBusy(true); try { await onSave(items.map((x) => x.id)); } finally { setBusy(false); } }}
                className="bg-blue-600 hover:bg-blue-500" data-testid="order-save">Sıralamayı Kaydet</Button>
      </DialogContent>
    </Dialog>
  );
}
